<template>
  <!-- 首页 -->
  <div id="home">
      
    <section><homemenu /></section>
    <section><advantage /></section>
    <section><homezxls /></section>
    <section class="w_bg80"><homezxflzx /></section>
	<section><homeyxls /></section>
	<section class="w_bg80"><homewtls /></section>
	<section ><homezyls /></section>
    <section class="w_bg80"><homeflzs /></section>
	<section><homeflrd /></section>
    
    <!-- <section><homecenterbanner /></section> -->
    
    
    <!-- <section><homehtxz /></section> -->
    <section class="w_bg80"><homehfzyls /></section>
    <section><homelsphb /></section>
    <section><advantage2 /></section>

    <!-- 右侧边栏 -->
    <lv-aside></lv-aside>
  </div>
</template>

<script>
import lvAside from "components/content/lvAside/lvAside";

import homemenu from "./child/homemenu"; //首页顶部菜单列表
import advantage from "./child/advantage"; //优势展示框
import advantage2 from "./child/advantage2"; //底部优势展示框
import homezxls from "./child/onlineLawyer"; //在线律师
import homezxflzx from "./child/onlineConsult"; //在线法律咨询
import homeflzs from "./child/legalKnowledge"; //法律知识
import homeflrd from "./child/laywerhot.vue"; //法律知识
import homeyxls from "./child/optimizingLawyer"; //优选律师
import homecenterbanner from "./child/homebanner2"; //中间banner横幅
import homewtls from "./child/entrustLawyer"; //委托律师
import homezyls from "./child/practicingLawyer"; //执业律师
import homehtxz from "./child/contractDownload"; //合同下载
import homehfzyls from "./child/majorLawyer.vue"; //合肥专业律师
import homelsphb from "./child/lawRankingList"; //律师排行榜

export default {
  name: "home",
  components: {
    lvAside,
    // 页面内
    homemenu,
    advantage,
    advantage2,
    homezxls,
    homezxflzx,
    homeflzs,
    homeyxls,
    homecenterbanner,
    homewtls,
    homezyls,
    homehtxz,
    homehfzyls,
    homelsphb,
	homeflrd
  },

};
</script>

<style lang="scss" scoped>
#home {
  background-color: #fff;
  .w_bg80 {
    width: 100%;
    background-color: #f8f8f8;
  }
}
</style>
